<script>
export default {
    name: 'oc-plugin-slot',
    functional: true,
    inheritAttrs: false,
    inject: {
        $plugins : {
            default: false
        },
        $source : {
            default: false
        }
    },
    props: {
        name: {
            type: [String, Number],
            required: true
        }
    },
    render(h, context) {
        let name = context.props.name
        let pluginsHandler = context.injections.$plugins

        if( pluginsHandler === false || context.injections.$source === false ) {
            return context.slots().default
        }

        let loadedPlugins = pluginsHandler.getLoadedPluginNames()
        let components = []

        // clone to fix vue custom js object behavior
        const attrs = Object.assign({}, context.data.attrs)

        for (let plugin of loadedPlugins)
        {
            if(
                ! pluginsHandler.getSlot(plugin, name) ||
                true !== pluginsHandler.getSlot(plugin, name).condition.apply(context.injections.$source, [attrs])
            ) {
                continue
            }

            components.push(
                h(
                    pluginsHandler.getSlot(plugin, name).component,
                    Object.assign({}, context.data, {
                        scopedSlots: context.scopedSlots,
                        slots: context.slots,
                        on: context.listeners
                    }),
                    context.children
                )
            )
        }

        if(components.length === 0) {
            return context.slots().default
        }

        return components
    }
}
</script>
